<p-card class="p-3" header="Datos generales">
    <form *ngIf="transactionSerieFormGroup" [formGroup]="transactionSerieFormGroup">

        <div class="grid">
            <div class="col-8 input-field">
                <label for="name">Nombre *</label>
                <input pInputText formControlName="name" d-form-field-error>
            </div>
            <div class="col-4 input-field">
                <label for="transactionTypeId">Tipo de transacción</label>
                <p-dropdown formControlName="transactionTypeId" [options]="transactionsTypes" optionLabel="name"
                    optionValue="id" placeholder="Selecciona tipo de transacción" d-form-field-error></p-dropdown>
            </div>
            <div class="col-4 input-field">
                <label for="prefix">Prefijo *</label>
                <input pInputText formControlName="prefix" d-form-field-error>
            </div>
            <div class="col-4 input-field">
                <label for="returnPrefix">Prefijo de abono *</label>
                <input pInputText formControlName="returnPrefix" d-form-field-error>
            </div>
            <div class="col-4 input-field">
                <label for="numberLength">Longitud de número</label>
                <p-inputNumber formControlName="numberLength" d-form-field-error></p-inputNumber>
            </div>
            <div class="col-4 input-field">
                <label for="firstNumber">Primer número</label>
                <p-inputNumber formControlName="firstNumber" d-form-field-error></p-inputNumber>
            </div>
            <div class="col-3 input-field">
                <label for="active">Activa</label>
                <p-inputSwitch formControlName="active" d-form-field-error></p-inputSwitch>
            </div>
            <div class="col-3 input-field">
                <label for="isDefault">Por defecto</label>
                <p-inputSwitch formControlName="isDefault" d-form-field-error></p-inputSwitch>
            </div>
        </div>
        <div class="mt-4 flex gap-2">
            <p-button label="Eliminar" *ngIf="allowDelete && transactionSerie?.id" icon="pi pi-trash"
                styleClass="p-button-danger" (click)="delete()"></p-button>
            <div class="flex-grow-1"></div>
            <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
            <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
                (click)="save()"></p-button>
        </div>
    </form>

</p-card>